module.exports = __webpack_public_path__ + "img/29.07048339.jpg";